import { Stack, Typography } from '@mui/material'
import React, { useCallback, useState } from 'react'
import RainbowTextField from '@components/RainbowTextField/RainbowTextField'
import { WALLET_SETUP_ROUTES } from '@utils/walletSetupRoutes'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import plug from '@assets/icons/plug-logo.png'
import Button from '@components/Button'
import { changePassword } from '@plug-core/handlers/walletActions/wallet'
import { logger } from '@plug-core/logger'
import { isWebEnvironment } from '@utils/environment'

export const WalletSetupPassword = () => {
  const navigate = useNavigate()

  const [password, setPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [repeatedPasswordError, setRepeatedPasswordError] = useState('')

  const { t } = useTranslation()

  const handleNextClick = async () => {
    await changePassword(password)
    if (isWebEnvironment()) {
      // On web, skip success screen and go directly to home
      // Force a page reload to trigger LockGuard to re-evaluate the state
      window.location.reload()
    } else {
      navigate(WALLET_SETUP_ROUTES.SUCCESS)
    }
  }

  const onNextClick = useCallback(() => {
    let passwordError = ''
    let repeatedPasswordError = ''

    if (password.length < 8) {
      passwordError = t('passwordSetup.passwordError')
      setPasswordError(passwordError)
    } else {
      setPasswordError(passwordError)
    }

    if (repeatPassword !== password) {
      repeatedPasswordError = t('passwordSetup.repeatedPasswordError')
      setRepeatedPasswordError(repeatedPasswordError)
    } else {
      setRepeatedPasswordError(repeatedPasswordError)
    }

    if (!passwordError && !repeatedPasswordError) {
      handleNextClick().catch((e) => logger.error('Unable to set password', { originalError: e }))
    }
  }, [password, repeatPassword])

  return (
    <Stack
      direction="column"
      spacing={2}
      alignContent="center"
      justifyContent="center"
      flex={1}
      height="100%"
      justifyItems="center"
      px={4}
    >
      <img src={plug} width="120px" style={{ alignSelf: 'center' }} />
      <Stack spacing={0.5}>
        <Typography fontWeight="bold" textAlign="center" variant="h5">
          {t('passwordSetup.title')}
        </Typography>
        <Typography textAlign="center" variant="body2" color="text.secondary">
          {t('passwordSetup.description')}
        </Typography>
      </Stack>
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            {t('passwordSetup.password')}
          </Typography>
          <RainbowTextField
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            autoFocus
            error={!!passwordError}
            errorMessage={passwordError}
          />
        </Stack>

        <Stack spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            {t('passwordSetup.repeatPassword')}
          </Typography>
          <RainbowTextField
            type="password"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
            fullWidth
            error={!!repeatedPasswordError}
            errorMessage={repeatedPasswordError}
            onKeyDown={(e) => e.key === 'Enter' && onNextClick()}
          />
        </Stack>
        <Button variant="rainbow" disabled={password.length === 0} onClick={onNextClick} fullWidth>
          {t('passwordSetup.set')}
        </Button>
      </Stack>
    </Stack>
  )
}
